import { render, staticRenderFns } from "./CreateEmailWorkflowPage.vue?vue&type=template&id=104c9808&scoped=true"
import script from "./CreateEmailWorkflowPage.vue?vue&type=script&lang=js"
export * from "./CreateEmailWorkflowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c9808",
  null
  
)

export default component.exports